module.exports = __webpack_public_path__ + "static/img/HOME1 1680x1050.0833628.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/landing/capacitador/home/HOME1 1680x1050.png
// module id = sime
// module chunks = 47